import { Renderer2 } from '@angular/core';
import { ContentRect } from './drag-selection.types';

export class MarqueeOverlay {
  private element: HTMLElement | null = null;

  constructor(private readonly renderer: Renderer2, private readonly parent: HTMLElement) {}

  public show(rect: ContentRect): void {
    const el = this.ensure();
    this.renderer.setStyle(el, 'left', `${rect.left}px`);
    this.renderer.setStyle(el, 'top', `${rect.top}px`);
    this.renderer.setStyle(el, 'width', `${rect.width}px`);
    this.renderer.setStyle(el, 'height', `${rect.height}px`);
    this.renderer.setStyle(el, 'display', 'block');
  }

  public hide(): void {
    if (!this.element) return;
    this.renderer.setStyle(this.element, 'display', 'none');
  }

  public destroy(): void {
    if (!this.element) return;
    this.renderer.removeChild(this.parent, this.element);
    this.element = null;
  }

  public hasElement(): boolean {
    return this.element !== null;
  }

  private ensure(): HTMLElement {
    if (this.element) return this.element;
    const el = this.renderer.createElement('div') as HTMLElement;
    this.renderer.setStyle(el, 'position', 'absolute');
    this.renderer.setStyle(el, 'border', '1px dashed #000');
    this.renderer.setStyle(el, 'background-color', 'rgba(0, 0, 255, 0.1)');
    this.renderer.setStyle(el, 'pointer-events', 'none');
    this.renderer.setStyle(el, 'display', 'none');
    this.renderer.setStyle(el, 'z-index', '1');
    this.renderer.setAttribute(el, 'aria-hidden', 'true');
    this.renderer.appendChild(this.parent, el);
    this.element = el;
    return el;
  }
}
